import { TConstructionStatus } from '@brickwise/asset-validation/dist/schema/enums';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultSelectField } from 'src/components/mui-overrides/SelectTextField';
import { useAssetType } from '../../../context-providers/asset-type/AssetTypeContext';
import { useFormikContext } from 'formik';

interface Props {
  disabled?: boolean;
}

export const ConstructionStatusSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const { assetType } = useAssetType();
  const formik = useFormikContext();

  let options = [
    {
      value: TConstructionStatus.stock,
      label: t('general.constructionStatus.stock'),
    },
    {
      value: TConstructionStatus.project,
      label: t('general.constructionStatus.project'),
    },
    {
      value: TConstructionStatus.planning,
      label: t('general.constructionStatus.planning'),
    },
  ];
  if (assetType === 'powerplantPortfolio') {
    options = [
      ...options,
      {
        value: TConstructionStatus.installed,
        label: t('general.constructionStatus.installed'),
      },
      {
        value: TConstructionStatus.connectedToNetwork,
        label: t('general.constructionStatus.connectedToNetwork'),
      },
    ];
  }
  return (
    <>
      <DefaultSelectField
        disabled={disabled}
        formik={formik}
        label={t('dashboard.assets.addedit.main.generalinfo.fields.constructionStatus.label')}
        fieldName="propertyDetails.constructionStatus"
        options={options}
      />
    </>
  );
};
